import React from 'react';

import Link from 'components/Editor/blocks/Link';
import Image from 'components/Editor/blocks/Image';
import Video from 'components/Editor/blocks/Video';
import Audio from 'components/Editor/blocks/Audio';
import Youtube from 'components/Editor/blocks/Youtube';
import Download from 'components/Editor/blocks/Download';
import Formula from 'components/Editor/blocks/Formula';
import Spellcheck from 'components/Editor/blocks/Spellcheck';
import { Table, Row, Cell } from 'components/Editor/blocks/Table';
import { Quiz, Question, Content, Option } from 'components/Editor/blocks/Quiz';

// Render elements in editor
// @attributes: array | modifier attributes
// @children: array | element's content
// @element: object | current element's data
const Element = ({ attributes, children, element }) => {
	switch (element.type) {
	case 'heading-one':
		return (
			<h1
				{...attributes}
				id={element.id}
				style={element.style}
				className="text-2xl font-bold tracking-wide text-neutral-800 dark:text-white transition-colors"
			>
				{children}
			</h1>
		);
	case 'heading-two':
		return (
			<h2
				{...attributes}
				id={element.id}
				style={element.style}
				className="text-xl font-bold tracking-wide text-neutral-800 dark:text-white transition-colors"
			>
				{children}
			</h2>
		);
	case 'heading-three':
		return (
			<h3
				{...attributes}
				id={element.id}
				style={element.style}
				className="text-lg font-bold tracking-wide text-neutral-800 dark:text-white transition-colors"
			>
				{children}
			</h3>
		);
	case 'blockquote':
		return (
			<blockquote
				{...attributes}
				style={element.style}
				className="py-4 pr-4 leading-7 bg-neutral-50 dark:bg-neutral-700 text-neutral-800 dark:text-white rounded-lg transition-colors"
			>
				{children}
			</blockquote>
		);
	case 'link':
		return (
			<Link
				{...attributes}
				href={element.href}
				style={element.style}
			>
				{children}
			</Link>
		);
	case 'image':
		return (
			<Image
				{...attributes}
				src={element.src}
				style={element.style}
			>
				{children}
			</Image>
		);
	case 'video':
		return (
			<Video
				{...attributes}
				src={element.src}
			>
				{children}
			</Video>
		);
	case 'audio':
		return (
			<Audio
				{...attributes}
				src={element.src}
			>
				{children}
			</Audio>
		);
	case 'download':
		return (
			<Download
				{...attributes}
				src={element.src}
			>
				{children}
			</Download>
		);
	case 'youtube':
		return (
			<Youtube
				{...attributes}
				href={element.href}
			>
				{children}
			</Youtube>
		);
	case 'formula':
		return (
			<Formula
				{...attributes}
				element={element}
			>
				{children}
			</Formula>
		);
	case 'table':
		return (
			<Table {...attributes}>
				{children}
			</Table>
		);
	case 'table-row':
		return (
			<Row {...attributes}>
				{children}
			</Row>
		);
	case 'table-cell':
		return (
			<Cell
				{...attributes}
				style={element.style}
			>
				{children}
			</Cell>
		);
	case 'bulleted-list':
		return (
			<ul
				{...attributes}
				className="ml-8 list-disc leading-7 text-neutral-800 dark:text-white transition-colors"
			>
				{children}
			</ul>
		);
	case 'numbered-list':
		return (
			<ol
				{...attributes}
				className="ml-8 list-decimal leading-7 text-neutral-800 dark:text-white transition-colors"
			>
				{children}
			</ol>
		);
	case 'list-item':
		return (
			<li {...attributes}>{children}</li>
		);
	case 'spellcheck':
		return (
			<Spellcheck
				{...attributes}
				element={element}
			>
				{children}
			</Spellcheck>
		);
	case 'quiz':
		return (
			<Quiz
				{...attributes}
				element={element}
			>
				{children}
			</Quiz>
		);
	case 'quiz-question':
		return (
			<Question
				{...attributes}
				element={element}
			>
				{children}
			</Question>
		);
	case 'quiz-content':
		return (
			<Content
				{...attributes}
				element={element}
			>
				{children}
			</Content>
		);
	case 'quiz-option':
		return (
			<Option
				{...attributes}
				element={element}
			>
				{children}
			</Option>
		);
	default:
		return (
			<div
				{...attributes}
				style={element.style}
				className="text-neutral-800 text-base leading-7 dark:text-white transition-colors"
			>
				{children}
			</div>
		);
	}
};

export default Element;
